import axios from "axios";
import { baseUrl } from "../../utils/baseUrl";


export const faqApi = async () => {
  try {
    const response = await axios.get(`${baseUrl}faq`);
    return response;
  } catch (error) {


    return null;
  } finally {
  }
};
